import React, { useState, useEffect } from "react";
import { useIsRootstockConnected } from "./useIsRootstockConnected";

const ROOTSTOCK_PARAMS = {
  chainId: "0x1e",
  chainName: "Rootstock Mainnet",
  nativeCurrency: { name: "RSK Smart Bitcoin", symbol: "RBTC", decimals: 18 },
  rpcUrls: ["https://public-node.rsk.co"],
  blockExplorerUrls: ["https://explorer.rsk.co"],
};

const AddRootstockButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasWallet, setHasWallet] = useState(false);
  const [justConnected, setJustConnected] = useState(false);
  const isConnected = useIsRootstockConnected();

  useEffect(() => {
    setHasWallet(typeof window !== "undefined" && !!window.ethereum);
  }, []);

  useEffect(() => {
    if (isConnected) {
      setJustConnected(true);
      const timer = setTimeout(() => setJustConnected(false), 1500);
      return () => clearTimeout(timer);
    }
  }, [isConnected]);

  const connectToRootstock = async () => {
    if (!window.ethereum) return;

    setIsLoading(true);

    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: ROOTSTOCK_PARAMS.chainId }],
      });
    } catch (switchError) {
      if (switchError.code === 4902) {
        try {
          await window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [ROOTSTOCK_PARAMS],
          });
        } catch (addError) {
          console.error("Add network error:", addError);
        }
      } else {
        console.error("Switch error:", switchError);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column align-items-center gap-3">
      {/* 🚀 Main Button Logic */}
      {!isConnected ? (
        <button
          onClick={connectToRootstock}
          className="btn-outline-white btn-lg btn"
          disabled={isLoading}
          title="Connect your wallet and add Rootstock to start exploring Bitcoin DeFi"
        >
          {isLoading && <span className="spinner" />}{" "}
          {isLoading ? "Connecting to your wallet..." : "Start using Rootstock"}
        </button>
      ) : justConnected ? (
        <div className="fade-in">
          <button className="btn-outline-white btn-lg btn" disabled>
            ✅ Rootstock network added
          </button>
        </div>
      ) : (
        <>
          <div className="fade-in">
            <a
              href="https://rootstock.io/use-cases/"
              className="btn-outline-white btn-lg btn"
            >
              Explore BTCFi
            </a>
          </div>

          <div className="fade-in">
            <div className="text-center mt-3">
              <a
                href="https://rootstock.io/rbtc/#get-rbtc"
                className="btn btn-link decoration-none"
                target="_blank"
                rel="noreferrer"
              >
                <span className="text-white decoration-none">
                  Ready to get rBTC?
                </span>{" "}
                Bridge Now
              </a>
            </div>
          </div>
        </>
      )}

      {/* 🦊 Wallet not detected */}
      {!hasWallet && (
        <p className="text-sm text-warning mt-2">
          MetaMask not detected.{" "}
          <a
            href="https://metamask.io/download"
            target="_blank"
            rel="noopener noreferrer"
          >
            Install MetaMask
          </a>{" "}
          to get started.
        </p>
      )}

      {/* ✨ Animation Styles */}
      <style>
        {`
          .spinner {
            border: 2px solid rgba(32, 32, 32, 0.3);
            border-top: 2px solid white;
            border-radius: 50%;
            width: 14px;
            height: 14px;
            animation: spin 0.6s linear infinite;
            display: inline-block;
            margin-right: 8px;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          .fade-in {
            animation: fadeIn 0.4s ease-in-out forwards;
            opacity: 0;
          }

          @keyframes fadeIn {
            0% { opacity: 0; transform: translateY(6px); }
            100% { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
};

export default AddRootstockButton;

